import { useState, useEffect } from "react";
import { fetchData } from "../../api";
import ServicesImg from "../../images/MAK04075-HDR.jpg"

export default function OurServices() {
    const [services, setServices] = useState([]);
    const [sectionSettings, setSectionSettings] = useState(null);

    useEffect(() => {
        fetchData("section-settings", true).then(data => setSectionSettings(data?.[0]));

        fetchData("servicetwos", true).then(data => {
            const sortedServices = data.sort((a, b) => (a.order || 0) - (b.order || 0));
            setServices(sortedServices);
        });
    }, []);
  if (!sectionSettings) return null;

    return (
        <section className="relative bg-cover bg-center py-16 px-4 md:px-16 ">
            <div className="text-center">
                {sectionSettings && (
                    <>
                        <h2 className="text-5xl md:text-6xl font-bold bg-gradient-to-r from-[#286766] via-[#27352C] to-[#286766] bg-clip-text text-transparent mb-6">{sectionSettings?.Text}</h2>
                        <div className="w-24 h-1 bg-gradient-to-r from-[#286766] to-[#27352C] mx-auto rounded-full"></div>
                        {/* <p className="italic mb-12 text-[#5A5A5A]">{sectionSettings?.Descriptio}</p> */}

                    </>
                )}
            </div>
            <div className="container grid grid-cols-[45%_1fr] max-lg:grid-cols-1 items-center gap-10 max-sm:px-0" style={{ marginTop: '70px' }}>
                <img className="rounded-2xl object-cover w-full h-full md:max-lg:h-[350px]" src={`${process.env.NEXT_PUBLIC_STRAPI_URL || "https://api.bouwbedrijfgeluk.nl"}${sectionSettings.mainImg?.url}`} />

                <div className="w-full">
                    <div className="grid grid-cols-2 gap-8 max-sm:grid-cols-1">
                        {services.map((service, index) => (
                            <div key={index} className="group">
                                <div className="bg-white rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 border border-gray-100 hover:border-[#286766]/30 h-full flex flex-col relative overflow-hidden">
                                    {/* Hover underline effect */}
                                    <div className="absolute bottom-0 left-0 w-0 h-1 bg-gradient-to-r from-[#286766] to-[#27352C] transition-all duration-300 group-hover:w-full"></div>
                                    
                                    {/* Header with clover */}
                                    <div className={`p-6 pb-4 flex items-center ${
                                        index === 0 || index === 2 ? 'justify-start' : 'justify-end'
                                    }`}>
                                        <div className="w-12 h-12 flex items-center justify-center">
                                            <img 
                                                className="h-8 w-8 object-contain filter drop-shadow-md transition-transform duration-300 group-hover:scale-110" 
                                                src={`${process.env.NEXT_PUBLIC_STRAPI_URL || "https://api.bouwbedrijfgeluk.nl"}${service.Icon?.url}`} 
                                                alt={service.Title} 
                                            />
                                        </div>
                                    </div>
                                    
                                    {/* Content with fixed height structure */}
                                    <div className="px-6 pb-6 flex-grow flex flex-col">
                                        <div className="text-center mb-6 flex-grow">
                                            <h4 className="font-bold text-xl mb-3 text-gray-900 group-hover:text-[#286766] transition-colors duration-300 min-h-[28px]">
                                                {service.Title}
                                            </h4>
                                            
                                            <p className="text-gray-600 leading-relaxed text-sm min-h-[60px] flex items-center justify-center">
                                                {service.Description}
                                            </p>
                                        </div>
                                        
                                        {/* Button with consistent positioning */}
                                        <div className="mt-auto pt-4">
                                            <a 
                                                href={service.Slug ? `/services/${service.Slug}` : '#'}
                                                onClick={(e) => {
                                                    if (!service.Slug) {
                                                        e.preventDefault();
                                                        alert('Deze service pagina is nog niet beschikbaar. Neem contact met ons op voor meer informatie.');
                                                    }
                                                }}
                                                className="inline-flex items-center justify-center gap-2 w-full bg-gradient-to-r from-[#286766] to-[#27352C] text-white py-3 px-4 rounded-xl font-semibold text-sm hover:shadow-lg hover:scale-105 transition-all duration-300 group/btn"
                                            >
                                                <span>{service.ReadMoreButtonText || "Lees meer"}</span>
                                                <svg className="w-4 h-4 transition-transform duration-300 group-hover/btn:translate-x-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" />
                                                </svg>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
}
